import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { FuseSharedModule } from '@fuse/shared.module';

import { HomeKlantComponent } from './homeKlant.component';

const routes = [
    {
        path     : 'homeklant',
        component: HomeKlantComponent
    }
];

@NgModule({
    declarations: [
        HomeKlantComponent
    ],
    imports     : [
        RouterModule.forChild(routes),

        TranslateModule,

        FuseSharedModule
    ],
    exports     : [
        HomeKlantComponent
    ]
})

export class HomeKlantModule
{
}
